// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-57d2f3a5] .basic__label-row-item-label{width:90px!important}", ""]);
// Exports
module.exports = exports;
